(function () {
  function initOffers(root) {
    const slides = Array.from(root.querySelectorAll('[data-offer-slide]'));
    if (slides.length < 2) return;

    let index = slides.findIndex((slide) => slide.classList.contains('is-active'));
    if (index < 0) index = 0;

    const counter = root.querySelector('[data-offer-counter]');
    const prev = root.querySelector('[data-offer-prev]');
    const next = root.querySelector('[data-offer-next]');

    const render = () => {
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
      });
      if (counter) counter.textContent = `${index + 1}/${slides.length}`;
    };

    const goNext = () => {
      index = (index + 1) % slides.length;
      render();
    };

    prev?.addEventListener('click', (event) => {
      event.stopPropagation();
      index = (index - 1 + slides.length) % slides.length;
      render();
    });

    next?.addEventListener('click', (event) => {
      event.stopPropagation();
      goNext();
    });

    root.querySelector('.pd-offers__track')?.addEventListener('click', goNext);

    let timer = setInterval(goNext, 4500);
    root.addEventListener('mouseenter', () => clearInterval(timer));
    root.addEventListener('mouseleave', () => {
      timer = setInterval(goNext, 4500);
    });

    render();
  }

  function initPincode(root) {
    const input = root.querySelector('[data-pincode-input]');
    const button = root.querySelector('[data-pincode-check]');
    const message = root.querySelector('[data-pincode-message]');
    if (!input || !button || !message) return;

    const show = (ok, pin) => {
      message.classList.remove('pd-pincode__message--ok', 'pd-pincode__message--err');
      if (ok) {
        message.classList.add('pd-pincode__message--ok');
        message.textContent = (message.dataset.msgOk || '').replace('__PIN__', pin);
      } else {
        message.classList.add('pd-pincode__message--err');
        message.textContent = message.dataset.msgErr || '';
      }
    };

    const check = () => {
      const pin = String(input.value || '').trim();
      show(/^\d{6}$/.test(pin), pin);
    };

    button.addEventListener('click', check);
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        check();
      }
    });
  }

  function initBuyNowIcon(root) {
    const inject = () => {
      const buttons = root.querySelectorAll(
        '.shopify-payment-button__button--unbranded:not([data-pd-icon])'
      );
      if (!buttons.length) return false;

      const svg =
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M13.05 2.2 6.1 13.15c-.3.48.05 1.1.62 1.1h4.55l-.9 7.35c-.1.8.9 1.25 1.35.6l6.95-10.95c.3-.48-.05-1.1-.62-1.1h-4.55l.9-7.35c.1-.8-.9-1.25-1.35-.6z"/></svg>';

      buttons.forEach((button) => {
        button.dataset.pdIcon = '1';
        if (button.querySelector('.pd-buy-now-icon')) return;
        const icon = document.createElement('span');
        icon.className = 'pd-buy-now-icon';
        icon.setAttribute('aria-hidden', 'true');
        icon.innerHTML = svg;
        button.prepend(icon);
      });
      return true;
    };

    if (inject()) return;

    const target = root.querySelector('.product-form__buttons') || root;
    const observer = new MutationObserver(() => {
      if (inject()) observer.disconnect();
    });
    observer.observe(target, { childList: true, subtree: true });
    setTimeout(() => observer.disconnect(), 8000);
  }

  function initPeekAccordions(root) {
    root.querySelectorAll('details.pd-peek-accordion').forEach((details) => {
      if (details.dataset.pdPeekInit === '1') return;
      details.dataset.pdPeekInit = '1';
      details.open = true;
      details.classList.remove('is-expanded');

      const summary = details.querySelector('summary');
      if (!summary) return;

      summary.setAttribute('aria-expanded', 'false');
      summary.addEventListener('click', (event) => {
        event.preventDefault();
        const expanded = details.classList.toggle('is-expanded');
        details.open = true;
        summary.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-pd-offers]').forEach(initOffers);
    document.querySelectorAll('[data-pd-pincode]').forEach(initPincode);
    document.querySelectorAll('.product-details').forEach((root) => {
      initBuyNowIcon(root);
      initPeekAccordions(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
